<template>
  <div v-if="tableDisplay == 'document_types'">
    <v-row style="margin-top: -83px">
      <v-spacer></v-spacer>
      <v-col cols="3" class="text-right"> 
        <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details>
          <template slot="append-outer">
          </template>
        </v-text-field>
      </v-col>
    </v-row>
     <v-row class="mb-n7 mt-n2" v-show="showSuccessMessage">
      <v-col cols="12">
        <v-alert dense text type="success" dismissible
          >Created New Document Type</v-alert
        >
      </v-col>
    </v-row>
    <v-row class="mb-n7 mt-n2" v-show="showSuccess">
      <v-col cols="12">
        <v-alert dense text type="success" dismissible
          >Updated Document Type</v-alert
        >
      </v-col>
    </v-row>
    <v-row class="mt-1">
      <v-col>
        <v-data-table
          v-model="selected"
          :single-select="false"
          :items="allDocumentTypes"
          :headers="headers"
          :items-per-page="10"
          class="elevation-2"
          item-key="id"
          :search="search"
          show-select
          :loading="isFetching"
          loading-text="Loading... Please wait"
        >
          <template v-slot:[`item.actions`]="{ item }">
            <v-icon small class="mr-2" @click="edit(item)">mdi-pencil</v-icon>
            <v-icon small @click="archive(item.id)">mdi-delete</v-icon>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <DocumentTypeCreateModal
      :dialog="dialog"
      :documentTypeUpdate="updateItem"
      @closeDialog="close"
    />
    <loading-overlay v-if="loading"/>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Swal from 'sweetalert2';
import LoadingOverlay from "../common/LoadingOverlay.vue";
import DocumentTypeCreateModal from "./DocumentTypeCreateModal";

export default {
  name: "DocumentTypesList",
  props: {
    tableDisplay: String,
    // search: String,
    isFetching: Boolean,
    dialog: Boolean
  },
  components: {
    DocumentTypeCreateModal,
    LoadingOverlay
  },
  data() {
    return {
      search: "",
      selected: [],
      singleSelect: false,
      headers: [
        {
          text: "Name",
          align: "start",
          sortable: true,
          value: "name",
        },
        { text: "Details", value: "details" },
        { text: "Date Created", value: "date" },
        { text: "Actions", value: "actions", sortable: false, align: "center" },
      ],
      showSuccess: false,
      showSuccessMessage: false,
      updateItem: null,
      loading: false,
    };
  },
  methods: {
    ...mapActions(["fetchDocumentTypes", "deleteDocumentType"]),
    close(action) {
      this.updateItem = null;
      // this.showSuccess = val ? true : false;
      this.$emit("closeDialog", false)
      if(action == "Update"){
        this.showSuccess = true;
        this.showSuccessMessage = false;
      }else if(action == "Create"){
        this.showSuccess = false;
        this.showSuccessMessage = true;
      }else if(action == "Close"){
        this.showSuccess = false;
        this.showSuccessMessage = false;
      }
    },
    edit(item) {
      this.updateItem = item;
      this.$emit("openDialog", "types")
      // this.dialog = true;
    },
    async archive(id) {
        Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, cancel!',
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          this.loading = true;
          this.deleteDocumentType(id)
            .then(() => {
              this.loading = false;
              Swal.fire(
                'Deleted!',
                'Your file has been deleted.',
                'success'
              )
            })
        }
      })
    }
  },
  computed: mapGetters(["allDocumentTypes"]),
};
</script>

<style>
</style>